/*
 * Ce script JavaScript gère le comportement d'un menu de navigation mobile sur un site web. 
 * Il effectue les opérations suivantes :
 *
 * - Déplace un lien de menu spécifique à la fin du menu principal.
 * - Supprime un élément parent inutile du DOM.
 * - Change l'icône du menu de navigation (du symbole "burger" à une croix et vice versa) lorsqu'il est cliqué.
 * - Déclenche l'affichage du menu de navigation en ajoutant ou en supprimant des classes spécifiques aux différents éléments concernés.
 */

// Sélection des éléments nécessaires
const body = document.querySelector("body");
const navMobile = document.querySelector("header nav.header-mobile-nav");
// const burgerMenuButton = document.querySelector(".mobile-nav-button");
const mobileMenuLink = document.querySelector("header nav.header-mobile-nav #block-lien-cta.menu--mcta li");
const lastElementInMainMenu = document.querySelector("#block-navigationprincipale.menu--main li:last-child");
const menuItemsContainer = document.querySelector("#block-navigationprincipale.menu--main ul");
const allMenuItems = document.querySelectorAll("#block-navigationprincipale.menu--main ul li");
const mobileMenuBackground = document.querySelector(".menu-mobile-bg");
const burgerMenuButton = document.getElementById("burger-menu");

// Déplacer le mobileMenuLink après le lastElementInMainMenu
lastElementInMainMenu.parentNode.insertBefore(
  mobileMenuLink,
  lastElementInMainMenu.nextSibling
);

// Supprimer l'élément parent de mobileMenuLink
const parentElementOfMobileMenuLink = document.querySelector("#block-lien-cta");
parentElementOfMobileMenuLink.parentNode.removeChild(parentElementOfMobileMenuLink);

burgerMenuButton.addEventListener("click", function () {
  // Basculer les classes pour le bouton du menu, le fond du menu, le conteneur des éléments du menu, la navigation mobile et le corps de la page
  // this.classList.toggle("fs");
  this.classList.toggle("open");
  mobileMenuBackground.classList.toggle("fs");
  menuItemsContainer.classList.toggle("fs");
  navMobile.classList.toggle("expanded");
  body.classList.toggle("fs");
});